module.exports = __webpack_public_path__ + "static/faq_shape_3-0c77b6960d09f07da474dea3a61d4455.svg";